import { Navigate, useParams } from "react-router-dom";

/**
 * Redirects /pts and /pts/* to / and /* so PTS routes work at root.
 */
const RedirectPtsToRoot = () => {
  const { "*": splat } = useParams<{ "*": string }>();
  const to = splat ? `/${splat}` : "/home";
  return <Navigate to={to} replace />;
};

export default RedirectPtsToRoot;
